/**
 * demographicStatus.js — now live.
 *
 * Replaces the earlier stub. Calls GET /v1/demographics/me, which
 * resolves the caller's platform_user identity server-side and returns
 * one of: 'no_submission' | 'pending_verification' | 'verified' | 'rejected'.
 * Non-patient roles get 'verified' back as a no-op, same contract as before.
 */
import { fetchMyDemographicStatus } from "./demographic";

export async function fetchDemographicStatus(currentUser) {
  if (!currentUser || currentUser.role !== "patient") {
    return { status: "verified" };
  }

  try {
    const data = await fetchMyDemographicStatus();
    return data;
  } catch (err) {
    console.error(
      "[demographicStatus] fetch failed:",
      err?.response?.data || err?.message || err,
    );
    // Fail toward the safer state: block dashboard access rather than
    // silently granting it if the status check itself is broken.
    return { status: "no_submission" };
  }
}
